/* SNACKS collection — craving filter + real-cart stash bar.
   Ported from the claude.ai/design prototype; the prototype's local
   tally is replaced with the real Shopify AJAX cart (/cart/add.js, /cart.js). */
(function () {
  "use strict";

  var root = document.querySelector("[data-sk-snacks-grid]");
  if (!root) return;

  var pills = Array.prototype.slice.call(root.querySelectorAll(".sk-snacks-grid__pill"));
  var cards = Array.prototype.slice.call(root.querySelectorAll(".sk-snacks-card"));
  var grid  = root.querySelector(".sk-snacks-grid__grid");
  var empty = root.querySelector(".sk-snacks-grid__empty");
  var resetBtn = root.querySelector("[data-sk-snacks-reset]");

  /* Hero "Shop the snacks" is a plain <a href="#…"> — the site-wide smooth scroll
     (html{scroll-behavior} + scroll-padding-top in tsk-custom.css / sk.liquid) now
     handles it, so no JS override is needed here. */

  /* ── Craving filter ─────────────────────── */
  function cardTags(card) {
    return (card.getAttribute("data-tags") || "").split(/\s+/).filter(Boolean);
  }

  // Compute + inject pill counts from the real cards present.
  pills.forEach(function (pill) {
    var f = pill.getAttribute("data-filter");
    var countEl = pill.querySelector(".count");
    if (!countEl) return;
    var n = (f === "all")
      ? cards.length
      : cards.filter(function (c) { return cardTags(c).indexOf(f) !== -1; }).length;
    countEl.textContent = n;
  });

  function applyFilter(tag) {
    var shown = 0;
    cards.forEach(function (card) {
      var match = tag === "all" || cardTags(card).indexOf(tag) !== -1;
      card.classList.toggle("hide", !match);
      if (match) {
        shown++;
        card.style.animation = "none";
        void card.offsetWidth;            // reflow → restagger the pop-in
        card.style.animation = "";
        card.style.animationDelay = (shown * 40) + "ms";
      }
    });
    if (empty) empty.classList.toggle("show", shown === 0);
  }

  pills.forEach(function (pill) {
    pill.addEventListener("click", function () {
      pills.forEach(function (p) { p.classList.remove("on"); });
      pill.classList.add("on");
      applyFilter(pill.getAttribute("data-filter"));
    });
  });

  if (resetBtn) {
    resetBtn.addEventListener("click", function () {
      var allPill = pills.filter(function (p) { return p.getAttribute("data-filter") === "all"; })[0] || pills[0];
      if (allPill) allPill.click();
    });
  }

  /* ── Card rails: ‹ › click-scroll on desktop, native swipe on mobile ── */
  Array.prototype.slice.call(root.querySelectorAll("[data-sk-rail]")).forEach(function (rail) {
    var track = rail.querySelector("[data-rail-track]");
    var prev  = rail.querySelector("[data-rail-prev]");
    var next  = rail.querySelector("[data-rail-next]");
    if (!track) return;

    // distance per click = however many whole cards currently fit (min 1)
    function step() {
      var card = track.querySelector(".sk-snacks-card");
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 16;
      var w = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.9;
      var per = Math.max(1, Math.floor(track.clientWidth / w));
      return w * per;
    }
    // hide an arrow when there's nothing more that way (or nothing overflows at all)
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var overflowing = max > 1;
      if (prev) prev.hidden = !overflowing || track.scrollLeft <= 1;
      if (next) next.hidden = !overflowing || track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left:  step(), behavior: "smooth" }); });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });

  /* ── "What are you craving?" jump chips → smooth-scroll to that aisle ──
     Header-offset-aware + reduce-motion-aware via the shared window.skScrollToEl
     (defined in the layout head). Distinct class from the legacy filter pills so
     the inert filter handler above can't grab these. */
  Array.prototype.slice.call(root.querySelectorAll("[data-snacks-jump]")).forEach(function (chip) {
    chip.addEventListener("click", function (e) {
      var id = (chip.getAttribute("href") || "").replace(/^#/, "");
      var target = id && document.getElementById(id);
      if (!target) return;                       // no target → let the native anchor run
      e.preventDefault();
      if (window.skScrollToEl) window.skScrollToEl(target, "start");
      else target.scrollIntoView();
    });
  });

  /* ── Stash bar → real Shopify cart ──────── */
  var stash = document.querySelector("[data-sk-snacks-stash]");
  if (!stash) return;

  var countEl = stash.querySelector(".count");
  var txtEl   = stash.querySelector(".txt");                 // .sk-orderbar__msg
  var totalEl = stash.querySelector("[data-stash-total]");   // .sk-orderbar__total
  var trackEl = stash.querySelector("[data-stash-track]");   // free-delivery meter track
  var fillEl  = stash.querySelector("[data-stash-fill]");    // meter fill
  var progEl  = stash.querySelector("[data-stash-progress]");
  var idleTxt = (txtEl && txtEl.textContent) || "Tap Add on anything tasty to get started";
  var threshold = parseInt(stash.getAttribute("data-free-threshold"), 10); // cents; 0/NaN = no meter

  function money(cents) {
    var n = cents / 100;
    return "$" + (Number.isInteger(n) ? n : n.toFixed(2));
  }

  /* Shared "Your box" order-bar layout: count badge + running total + free-delivery meter,
     identical to the single-meals bag (assets/sk-orderbar.css). */
  function renderStash(cart) {
    var items = cart ? cart.item_count : 0;
    var total = cart ? cart.total_price : 0; // cents
    if (countEl) {
      countEl.textContent = items;
      countEl.classList.add("bump");
      setTimeout(function () { countEl.classList.remove("bump"); }, 250);
    }
    if (totalEl) totalEl.textContent = items > 0 ? "· " + money(total) : "";

    var hasMeter = threshold && threshold > 0 && items > 0;
    if (trackEl) trackEl.hidden = !hasMeter;
    if (fillEl && hasMeter) fillEl.style.width = Math.min(100, Math.round((total / threshold) * 100)) + "%";
    if (progEl) progEl.classList.toggle("is-done", hasMeter && total >= threshold);

    if (txtEl) {
      if (items === 0) {
        txtEl.textContent = idleTxt;
      } else if (!threshold || threshold <= 0) {
        txtEl.textContent = money(total) + " in your box";
      } else if (total >= threshold) {
        txtEl.innerHTML = "<b>" + money(total) + " in your box</b>";
      } else {
        txtEl.innerHTML = money(threshold - total) + " to go";
      }
    }
  }

  function refreshCart(showBar) {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderStash(cart);
        if (showBar && cart.item_count > 0) stash.classList.add("show");
      })
      .catch(function () { /* leave idle state */ });
  }

  cards.forEach(function (card) {
    var btn = card.querySelector(".sk-snacks-card__add");
    if (!btn) return;
    var variantId = card.getAttribute("data-variant-id");
    if (!variantId) { btn.setAttribute("disabled", "disabled"); return; }
    var label = btn.textContent;

    btn.addEventListener("click", function () {
      btn.setAttribute("disabled", "disabled");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () {
          btn.classList.add("added");
          btn.textContent = "Added ✓";
          stash.classList.add("show");
          refreshCart(true);
          // keep the site-wide cart drawer + header count in sync (no auto-open,
          // so rapid multi-add on the snacks grid stays smooth — the stash bar gives feedback)
          document.dispatchEvent(new CustomEvent("sk-cart:refresh"));
          setTimeout(function () {
            btn.classList.remove("added");
            btn.textContent = label;
            btn.removeAttribute("disabled");
          }, 1600);
        })
        .catch(function (err) {
          btn.removeAttribute("disabled");
          var msg = (err && err.description) || "Couldn't add that. Please try again.";
          if (txtEl) txtEl.textContent = msg;
          /* eslint-disable-next-line no-console */
          console.error("Snacks add-to-cart failed:", err);
        });
    });
  });

  // Reveal the bar once the grid scrolls into view, and seed it with the live cart.
  if ("IntersectionObserver" in window && grid) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { stash.classList.add("show"); obs.disconnect(); }
      });
    }, { threshold: 0.05 });
    obs.observe(grid);
  }
  refreshCart(false);

  // Stay in sync when the cart changes ANYWHERE else (drawer remove / qty step,
  // PDP add, header). Those surfaces fire these shared events after they mutate
  // the cart; re-pull /cart.js so the stash count + free-delivery meter match.
  document.addEventListener("sk-cart:refresh", function () { refreshCart(false); });
  document.addEventListener("sk-cart:added",   function () { refreshCart(false); });
  /* The bar floats (position:fixed) and dips away near the footer (see snippets/sk-reveal.liquid
     + the body.sk-at-footer rules in sk-orderbar.css), so no bottom-padding reservation is needed. */
})();
